// pages/goodbye.tsx
"use client";
import { Button, Center, Container, Stack, Text, Title, Box } from "@mantine/core";
import { useRouter } from "next/navigation";


function Goodbye() {
  const router = useRouter();

  const handleGoHome = () => {
    router.push("/");
  };

  return (
    <Container size="xl" py="lg" pos="relative">
      <Center>
        <Stack align="center" gap="xl">
          <Title order={1}>Goodbye!</Title>
          <Box>
            <Text size="md" ta="center">
              Thanks for using ColorAnalysisTech. We're sad to see you go, but we hope you had a good experience.
            </Text>
            <Text size="md" ta="center">
              If you ever change your mind, you're always welcome back.
            </Text>
          </Box>
          <Button size="md" variant="outline" onClick={handleGoHome}>
            Go to Homepage
          </Button>
        </Stack>
      </Center>
    </Container>
  );
}

export default Goodbye;
